<template>
  <div class="course-info" v-if="course">
    <div
        class="container-fluid poli-course-header"
        :style="{ 'backgroundColor': course.color }"
    >
      <div class="container">
        <div
            class="row alternative-bg"
            :style="bgLogoStyles"
        >
          <div class="col-xl-4 col-12 text-center">
            <img
                class="max-width-100-non-xl ml-xl-n6"
                :src="course.courseheader"
                :style="leftLogoStyles"
            />
          </div>
          <div class="col-xl-4 col-12 text-center">
            <div class="poli-c-name mt-xl-5"
                 :style="courseTextStyle(course.textcolor ? course.textcolor : course.color_header, course.shadowcolor ?  course.shadowcolor : course.shadow_header)">
              {{ course.course }}
            </div>

            <div
                class="poli-c-desc mt-xl-3"
                :style="courseTextStyle(course.textcolor ? course.textcolor : course.textcolor, course.color_header ?  course.shadowcolor : course.shadow_header)"
                v-if="course.name2"
            >
              {{ course.name2 }}
            </div>

            <div class="poli-c-lang"
                 :style="courseTextStyle(course.textcolor ? course.textcolor : course.color_language, course.shadowcolor ?  course.shadowcolor : course.shadow_language)"
            >
              [{{ language }}]
            </div>
            <div class="poli-c-age mt-xl-2 mb-4"
                 :style="courseTextStyle(course.textcolor ? course.textcolor : course.color_age, course.shadowcolor ?  course.shadowcolor : course.shadow_age)">
              {{ age }}
            </div>
          </div>
          <div class="col-xl-4 col-12 text-center d-xl-inline-block d-none">
            <img
                class="max-width-100-non-xl mb-xl-n6 ml-xl-n8"
                :src="course.courseheader2"
                :style="rightLogoStyles"
            />
          </div>
        </div>
      </div><!-- /.container -->
    </div><!-- /.container-fluid -->

    <div class="container">
      <div class="row justify-content-lg-end justify-content-center mt-lg--6 mt-4 d-lg-none d-flex text-left">
        <div class="col-1"></div>
        <div class="col-10">
          <CourseTrained v-if="course.trained" :trained="course.trained"/>
        </div>
        <div class="col-1"></div>
      </div>

      <h1 class="course-info-title mt-5">
        {{ course.course }}
        <img
            class="course-info-title__badge"
            :src="require(`@/assets/hometeacher/images/${difficlty}.png`)"
        >
      </h1>

      <div class="row">
        <div class="col-xl-4 col-12 order-sm-2">

          <div class="row">
            <div class="col-lg-auto">
              <div class="video_wrapper mb-4 d-sm-none d-block">
                <iframe
                    allowfullscreen
                    frameborder="0" width="100%" height="100%"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    class="rounded-xl"
                    :src="`https://www.poliglotiki.ru/embed/${course.introvideo}?controls=0`"
                ></iframe>
              </div>
            </div>
          </div>

          <div class="row justify-content-lg-end justify-content-center mt-lg--6 mt-4 d-lg-flex d-none">
            <div class="col-lg-auto d-lg-flex d-none"></div>
            <div class="col-lg-auto">
              <CourseTrained v-if="course.trained" :trained="course.trained"/>
            </div>
          </div>

          <div class="course-order zapis row align-items-center mb-3">
            <div class="col-sm-6 text-lg-right mb-3 mb-sm-0" v-if="!course.ordered && !course.partial_pay">
              <span class="cena">{{ price | formatPrice }}</span> {{ $t('cur') }}
              <span
                  class="rub"
                  v-if="priceBefore && priceBefore > 0"
              >
                <s>{{ priceBefore | formatPrice }} {{ $t('cur') }}</s>
              </span>
            </div>
            <div class="col-sm-6 text-lg-right mb-3 mb-sm-0" v-else-if="!course.ordered && course.partial_pay">
              {{ $t('ot') }}&nbsp;<span class="cena">{{ course.partial_pay_amount | formatPrice }}</span>{{ $t('cur') }}
              <span
                  class="rub"
                  v-if="priceBefore && priceBefore > 0"
              >
                <s>{{ priceBefore | formatPrice }} {{ $t('cur') }}</s>
              </span>
            </div>
            <div class="col-sm-6 text-lg-right mb-3 mb-sm-0" v-else></div>
            <div class="col-sm-6">
              <base-button
                  :data-id="course.idcourse"
                  data-model="course"
                  :data-price="course.price"
                  data-action="order"
                  :data-label="orderButton.label"
                  class="ma-0 btn-block"
                  @click="order"
              >
                {{ orderButton.label }}
              </base-button>
            </div>
          </div><!-- /.order -->

          <CourseDop
              class="mb-3"
              :course="course"
              @additionalChange="additionalChange"
          />

          <CourseSet
              class="mb-3"
              :course="course"
              v-if="course.sostav_val1 || course.sostav_val2 || course.sostav_val3 || course.sostav_val4 || course.sostav_val5"
          />


          <div class="text-sm-right mb-3 mr-lg-0 ml-lg-0 mr-3 ml-3"
               v-if="course.freeLessonsCount > 0 && !course.ordered">
            <router-link
                class="btn btn-info ui-btn ui-btn--info d-block d-sm-inline-block"
                :to="{ name: 'lesson', params: { id: course.freeLessonsIds[0] }}"
            >
              {{ $t('try_trial_lesson') }}
            </router-link>
          </div>


          <div class="course-lessons-list-link text-sm-right text-center mb-3">
            <router-link
                class="course-lessons"
                :to="{ name: 'course' }"
            >
              {{ $t('lessons_list') }} ({{ course.lessonscount }})
            </router-link>
          </div>

          <CourseGoals
              class="mb-3"
              :course="course"
              v-if="course.result_achiev_val1 || course.result_achiev_val2 || course.result_achiev_val3 || course.result_achiev_val4 || course.result_achiev_val5"
          />

          <CourseRequirements
              class="mb-3"
              :course="course"
          />

          <CourseGift
              class="mb-3 d-lg-block d-none"
              :course="course"
          />

        </div>

        <div class="col-xl-8 col-12 order-sm-1">
          <div class="video_wrapper mb-4 d-sm-block d-none">
            <iframe
                allowfullscreen
                frameborder="0" width="100%" height="100%"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                class="rounded-xl"
                :src="`https://www.poliglotiki.ru/embed/${course.introvideo}?controls=0`"
            ></iframe>
          </div>

          <div>
            <CourseCertificate
                class="mb-3"
                :course="course"
            />

            <div class="course-description-full" v-html="course.description_full"></div>

          </div>

          <!-- <CourseCommentsAdvent
                  :course="course"
                  v-if="course.idcourse && course.idcourse === 45"
          /> -->


          <div
              class="ui-messagebox"
              v-if="course.result_header && course.result_text"
          >
            <div class="ui-messagebox__icon">
              <svg height="32px" viewBox="0 -21 512.016 512" width="32px"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="m234.667969 469.339844c-129.386719 0-234.667969-105.277344-234.667969-234.664063s105.28125-234.6679685 234.667969-234.6679685c44.992187 0 88.765625 12.8203125 126.589843 37.0976565 7.425782 4.78125 9.601563 14.679687 4.820313 22.125-4.796875 7.445312-14.675781 9.597656-22.121094 4.820312-32.640625-20.972656-70.441406-32.042969-109.289062-32.042969-111.746094 0-202.667969 90.921876-202.667969 202.667969 0 111.742188 90.921875 202.664063 202.667969 202.664063 111.742187 0 202.664062-90.921875 202.664062-202.664063 0-6.679687-.320312-13.292969-.9375-19.796875-.851562-8.8125 5.589844-16.621094 14.378907-17.472656 8.832031-.8125 16.617187 5.589844 17.472656 14.378906.722656 7.53125 1.085937 15.167969 1.085937 22.890625 0 129.386719-105.277343 234.664063-234.664062 234.664063zm0 0"/>
                <path
                    d="m261.332031 288.007812c-4.09375 0-8.191406-1.558593-11.304687-4.691406l-96-96c-6.25-6.253906-6.25-16.386718 0-22.636718s16.382812-6.25 22.632812 0l84.695313 84.695312 223.335937-223.339844c6.253906-6.25 16.386719-6.25 22.636719 0s6.25 16.382813 0 22.632813l-234.667969 234.667969c-3.136718 3.113281-7.230468 4.671874-11.328125 4.671874zm0 0"/>
              </svg>
            </div>
            <h2 class="ui-messagebox__title">
              {{ $t('result') }} - {{ course.result_header }}:
            </h2>
            {{ course.result_text }}
          </div>

          <div
              class="h1 ui-slogan-text mt-5 mb-3"
              v-if="course.slogan"
          >
            {{ course.slogan }}
          </div>

          <div class="ui-principle-text mb-4" v-html="$t('parents_requirements')"
               v-if="flavorConfig.showParentsRequirementsBlock">
          </div>
          <div class="ui-principle-items row text-center" v-if="flavorConfig.showParentsRequirementsBlock">
            <div class="col-12 col-lg-4 ui-principle-item">
              <div class="ui-principle-item-point">1.</div>
              <div class="ui-principle-item-text mt--2">{{ $t('parents_requirements_1') }}</div>
            </div>
            <div class="col-12 col-lg-4 ui-principle-item ui-principle-item-middle">
              <div class="ui-principle-item-point">2.</div>
              <div class="ui-principle-item-text mt--2">{{ $t('parents_requirements_2') }}</div>
            </div>
            <div class="col-12 col-lg-4 ui-principle-item">
              <div class="ui-principle-item-point">3.</div>
              <div class="ui-principle-item-text mt--2">{{ $t('parents_requirements_3') }}</div>
            </div>
          </div>

          <div
              class="h1 ui-slogan-text mt-4 mb-4"
          >
            {{ $t('effective_slogan') }}
          </div>

          <div class="row" v-if="course && course.authors && course.authors.length > 0">
            <div class="col-12 text-center course-author-header" v-if="course.authors.length === 1">
              {{ $t('course_author') }}
            </div>
            <div class="col-12 text-center course-author-header" v-else>{{ $t('course_authors') }}</div>
            <div class="col-12">
              <AuthorsGallery :authors="course.authors"/>
            </div>
          </div>
        </div>
      </div><!-- /.row -->
    </div><!-- /.container -->

    <CourseMetodics v-if="course.metodics_block"/>

    <CourseSteps v-if="course" :course="course"/>

    <CourseSkills v-if="course" :course="course"/>

    <CourseAdvantages v-if="course" :course="course"/>

    <CourseHowVideo v-if="course" :course="course"/>

    <CourseRelated v-if="course" :course="course"/>

    <CourseGift
        class="mb-3 d-lg-none d-block"
        :course="course"
    />

    <CourseSkorochtenieResult v-if='course && course.course && course.course.includes("Скорочтение")'/>

    <div class="container">
      <CourseComments
          :course="course"
          v-if="course.idcourse"
      />
    </div><!-- /.container -->

    <div class="container-fluid feedback-head-bg"></div>
    <entry/>
  </div>
</template>

<script>
import courseApi from '../data/CourseApi';

import CourseSet from './CourseComponents/CourseSet';
import CourseDop from './CourseComponents/CourseDop';
import CourseGoals from './CourseComponents/CourseGoals';
import CourseComments from './CourseComponents/CourseComments';
import CourseRequirements from './CourseComponents/CourseRequirements';
import Entry from "./Entry";
import numeral from 'numeral';
import CourseCertificate from "./CourseComponents/CourseCertificate";
import CourseGift from './CourseComponents/CourseGift';
import CourseCommentsAdvent from "./CourseComponents/CourseCommentsAdvent";
import CourseMetodics from "./CourseComponents/CourseMetodics";
import CourseSteps from "./CourseComponents/CourseSteps";
import CourseSkills from "./CourseComponents/CourseSkills";
import CourseAdvantages from "./CourseComponents/CourseAdvantages";
import CourseHowVideo from "./CourseComponents/CourseHowVideo";
import CourseRelated from "./CourseComponents/CourseRelated";
import CourseSkorochtenieResult from "./CourseComponents/CourseSkorochtenieResult";
import AuthorsGallery from "./author/AuthorsGallery";
import AuthorPopup from "./author/AuthorPopup";
import CourseTrained from "./CourseComponents/CourseTrained";

export default {
  name: 'CourseDetails',
  props: {
    slug: [String, Number],
  },

  data() {
    return {
      course: null,
      dopActivated: false,
      metaTitle: this.$t("course_details_default_title"),
      metaTitles: this.$t("course_details_metaTitles"),
      metaDescription: '',
      metaDescriptions: this.$t("course_details_metaDescriptions"),
    }
  },
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        {vmid: 'description', name: 'description', content: this.metaDescription}
      ]
    }
  },
  mounted() {
    courseApi.fetchCourseBySlug(this.slug)
        .then(response => {
          this.course = response;
          this.metaTitle = this.metaTitles[String(this.course.idcourse)]
          this.metaDescription = this.metaDescriptions[String(this.course.idcourse)]

          window.dataLayer.push({
            "ecommerce": {
              "detail": {
                "products": [
                  {
                    "id": this.course.idcourse,
                    "name": this.course.course,
                    "price": this.course.price,
                    "brand": this.$t("poliglotiki"),
                    "category": this.$t("course"),
                    "position": this.course.pos,
                    //"variant" : this.language
                  },
                ]
              }
            }
          })

        })
        .catch(error => {
          this.error = this.pretty(error.response.data);
          console.log(error)
          if (error.response.status === 404 || error.response.status === 403) {
            window.location.href = "/404"
          }
        });

  },

  computed: {
    bgLogoStyles() {
      if (this.course.background) {
        return {
          backgroundImage: `url('${this.course.background}')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
        };
      }
      return null;
    },

    leftLogoStyles() {
      return {
        paddingTop: `${this.course.courseheader_mt}px`,
        paddingLeft: `${this.course.courseheader_ml}px`,
        paddingRight: `${this.course.courseheader_mr}px`,
        paddingBottom: `${this.course.courseheader_mb}px`,
      };
    },

    rightLogoStyles() {
      return {
        paddingTop: `${this.course.courseheader2_mt}px`,
        paddingLeft: `${this.course.courseheader2_ml}px`,
        paddingRight: `${this.course.courseheader2_mr}px`,
        paddingBottom: `${this.course.courseheader2_mb}px`,
      };
    },

    orderButton() {
      if (this.course.ordered) {
        return {
          label: this.$t('go_to'),
          route: `/course/${this.course.slug}`,
        };
      } else if (parseInt(this.course.price) === 0) {
        return {
          label: this.$t('subscribe'),
          route: `/course/${this.course.slug}`,
        };
      } else {
        return {
          label: this.course.preorder ? this.$t('preorder') : this.$t('buy'),
          route: `/order/${this.course.idcourse}`,
        };
      }
    },

    language() {
      if (this.course.idlanguage) {
        return courseApi.getLanguageName(this.course.idlanguage);
      }
      return '-';
    },

    age() {
      if (this.course.ages && this.course.ages.length > 0) {
        let ages = [];
        for (let age of this.course.ages) {
          ages.push(courseApi.getAgeName(age.idage))
        }
        return ages.join(', ');
      }
      return courseApi.getAllAgeNames();
    },

    difficlty() {
      return this.course.difficulty
          ? courseApi.getDifficultyName(this.course.difficulty).toLowerCase()
          : 'easy';
    },

    price() {
      if (this.course.ordered && this.course.additional_package_enabled && this.dopActivated) return this.course.additional_package_price
      if (!this.course.ordered && this.course.additional_package_enabled && this.dopActivated) return this.course.full_price
      return this.course.price
    },

    priceBefore() {
      if (this.course.ordered && this.course.additional_package_enabled && this.dopActivated) return this.course.additional_package_price_before
      if (!this.course.ordered && this.course.additional_package_enabled && this.dopActivated) return this.course.full_price_before
      return this.course.pricebefore
    },
  },

  methods: {
    fetchComments() {
      courseApi.fetchComments(this.course.idcourse)
          .then(comments => {
            this.comments = comments;
          });
    },

    additionalChange(activated) {
      this.dopActivated = activated
    },

    order() {
      if (this.course.ordered) {
        if (this.dopActivated) {
          this.$router.push('/order/' + this.course.idcourse + '?addonly')
        } else {
          this.$router.push('/course/' + this.course.slug)
        }
      } else {
        if (this.dopActivated) {
          this.$router.push('/order/' + this.course.idcourse + '?add')
        } else {
          this.$router.push('/order/' + this.course.idcourse)
        }
      }
    },

    courseTextStyle(textColor, shadowColor) {
      if (textColor && shadowColor) {
        return {
          color: textColor,
          textShadow: "2px 2px " + shadowColor,
        }
      }

      return null
    },

    pretty(value) {
      if (value.message) {
        return value.message
      }
      return JSON.stringify(value, null, 2)
    },
  },

  filters: {
    formatPrice: function (value) {
      return numeral(value).format("0,0.00").replace(/\.0+$/, '').replace(/,/g, '\u00A0')
    }
  },

  components: {
    CourseTrained,
    AuthorPopup,
    AuthorsGallery,
    CourseCommentsAdvent,
    CourseCertificate,
    CourseSet,
    CourseDop,
    CourseGoals,
    CourseComments,
    CourseRequirements,
    CourseGift,
    CourseMetodics,
    CourseSteps,
    CourseSkills,
    CourseAdvantages,
    CourseHowVideo,
    CourseRelated,
    CourseSkorochtenieResult,
    Entry,
  }
}
</script>
<style src="@/assets/poliglotiki/main.css">
</style>
<style scoped>
@media (max-width: 991.8px) {
  .course-order.zapis,
  .course-lessons-list-link,
  .course-description-full {
    padding-right: 15px;
    padding-left: 15px;
  }

  .course-info-title,
  .ui-messagebox {
    margin-left: 15px;
    margin-right: 15px;
  }

  .ui-slogan-text {
    margin-left: 20px;
    margin-right: 20px;
  }
}

</style>

<style>

.course-description-full b, .course-description-full strong {
  font-family: "Manrope Bold";
}

.course-author-header {
  font-family: "Manrope Bold";
  font-size: 30px;
  color: #231c37;
  text-align: center;
}


h1, h2, h3 {
  font-family: 'Manrope Bold', 'Open Sans', sans-serif;
}

.course-info {
  font-family: 'Manrope Light', 'Open Sans', sans-serif;
}

.course-info-title {
  position: relative;
}

.course-info-title__badge {
  position: absolute;
  top: -10px;
}

.course-lessons {
  font-family: 'Manrope Bold', 'Open Sans', sans-serif;
  text-decoration: underline;
}

.ui-messagebox {
  border: 3px solid #6abe4c;
  border-radius: 1rem;
  padding: 25px;
  position: relative;
}

.ui-messagebox__icon {
  fill: #6abe4c;
  position: absolute;
  top: 20px;
  right: 20px;
}

.ui-btn {
  border-radius: 18px;
  font-family: 'Manrope Bold', 'Open Sans', sans-serif;
  font-size: 18px;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, .2);
}

.ui-btn--info {
  background: rgb(0, 189, 253);
  background: linear-gradient(0deg, rgba(5, 139, 202, 1) 0%, rgba(0, 189, 253, 1) 100%);
  border: none;
}

.video_wrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9, for an aspect ratio of 1:1 change to this value to 100% */
}

.video_wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ui-slogan-text {
  font-family: "Manrope Bold";
  color: #f15b22;
  font-size: 24px;
}

.ui-principle-text {
  font-family: Manrope Bold;
  font-size: 24px;
  color: #231c37;
  line-height: 30px;
}

.ui-principle-text span {
  color: #5ab947;
}

.ui-principle-items {
  background: #5ab947;
  padding: 30px 0;
  font-family: Manrope Bold;
}

.ui-principle-item-point {
  font-size: 30px;
  color: #fcff00;
}

.ui-principle-item-text {
  font-size: 21px;
  color: #ffffff;
}

@media (min-width: 992px) {
  .ui-principle-item-middle {
    border-left: 1px solid;
    border-right: 1px solid;
    border-color: #7dde69;
  }

  .ui-principle-items {
    border-radius: 10px;
  }
}

@media (max-width: 991.8px) {
  .ui-principle-text {
    padding-left: 20px;
    padding-right: 20px;
  }

  .ui-principle-item-middle .ui-principle-item-point {
    border-top: 1px solid;
    border-color: #7dde69;
    margin-top: 20px;
  }

  .ui-principle-item-middle .ui-principle-item-text {
    border-bottom: 1px solid;
    border-color: #7dde69;
  }

  .ui-principle-item-middle .ui-principle-item-text {
    padding-bottom: 25px;
  }

  .ui-principle-item-point {
    padding-top: 30px;
  }

  .ui-principle-items {
    padding-top: 0;
  }
}

</style>

<style src="@/assets/hometeacher/css/main.css"></style>
